import {
    createItemSummaryCard,
    IItemSummaryCardProperties,
    ItemSummaryCard,
} from '@vfde-brix/ws10/item-summary-card';
import { getDeviceSubline } from 'Container/App/helpers/getDeviceSubline';
import {
    createComponentById,
    NO_PATTERN_BUSINESS_LOGIC,
} from '@vfde-brix/ws10/core';
import {
    selectCustomerConfig,
    selectHasActiveDevice,
    selectHasDevice,
    toggleDevice,
} from 'Container/App/slice';
import { useDispatch } from '../store';
import { startAppListening } from 'Container/App/listener';
import {
    createStructuredAppSelector,
    selectDeviceData,
} from 'Container/App/selectors';
import { ITEM_SUMMARY_CARD } from 'Container/App/constants';

const mapStateToItemSummaryCardProps = createStructuredAppSelector({
    device: selectDeviceData,
    customerConfig: selectCustomerConfig,
});

/**
 * Mount device card
 */
export default function mountItemSummaryCard (): ItemSummaryCard | null {
    const dispatch = useDispatch();

    const itemSummaryCard = createComponentById(
        createItemSummaryCard,
        ITEM_SUMMARY_CARD,
        { onDeleteButtonClick: () => dispatch(toggleDevice()) },
    );

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectHasDevice(currentState) !== selectHasDevice(previousState)
            || selectHasActiveDevice(currentState) !== selectHasActiveDevice(previousState),
        effect: (_action, api) => {
            const hasActiveDevice = selectHasActiveDevice(api.getState());

            itemSummaryCard?.toggleContainer(!hasActiveDevice);
        },
    });

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectDeviceData(currentState) !== selectDeviceData(previousState)
            || selectCustomerConfig(currentState) !== selectCustomerConfig(previousState),
        effect: (_action, api) => {
            const props = mapStateToItemSummaryCardProps(api.getState());

            itemSummaryCard && updateItemSummaryCard(itemSummaryCard, props);
        },
    });

    return itemSummaryCard;
}

/**
 * Update device card
 */
export const updateItemSummaryCard = (
    itemSummaryCard: ItemSummaryCard,
    state: ReturnType<typeof mapStateToItemSummaryCardProps>,
) => {
    const { device: hardware } = state;
    const properties: IItemSummaryCardProperties = itemSummaryCard.getProperties();

    const onButtonLinkClick = (event: Event, _linkIndex: number, _itemIndex: number, href: string) => {
        event.preventDefault();
        window.location.assign(href);
    };

    itemSummaryCard.update({
        items: [
            {
                ...properties.items![0],
                ...hardware && ({
                    stdHeadline: `${hardware.modelName} | ${hardware.color.displayLabel} | ${hardware.capacity.displayLabel}`,
                    stdSubline: getDeviceSubline(state),
                    image: {
                        imgSrcDesktop: hardware.galleryImageUrl,
                    },
                    buttonLinkItems: [
                        {
                            ...properties.items![0].buttonLinkItems![0],
                            linkHref: hardware.hubpageUrl,
                        },
                        {
                            ...properties.items![0].buttonLinkItems![1],
                        },
                    ],
                }),
                business: NO_PATTERN_BUSINESS_LOGIC,
            },
        ],
        business: {
            ...properties.business,
            onButtonLinkClick,
        },
    });
};
